import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { inputAppReducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { AppMasterDBEffects } from './app-master-db/app-master-db.effects';
import { ShiftsEffects } from './shifts/shifts.effects';
import { MasterDataDBEffects } from './master-data-db/master-data-db.effects';
import { InputAppMetadataEffects } from './metadata/metadata.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot(inputAppReducer),
    EffectsModule.forRoot([AppMasterDBEffects, ShiftsEffects, MasterDataDBEffects, InputAppMetadataEffects]),
    StoreDevtoolsModule.instrument({ maxAge: 10 }),
  ],
})
export class ReduxStoreModule {}
